






























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import { maskCPFCNPJ } from '@/utils/common'
import moment from 'moment'

@Component
export default class SuporteContratosDetails extends Vue {

  statusColors: { [key: string]: object } = {
    Ativo: {
      text: 'green',
      bg: 'light-green lighten-4',
    },
    Inativo: {
      text: 'red',
      bg: 'red lighten-4',
    },
    Pendente: {
      text: 'orange',
      bg: 'orange lighten-4',
    },
  }

  profissionaisTableHeader: Array<object> = [
    { text: 'Nome', value: 'nome', align: 'start' },
    { text: 'Documento', value: 'documento' },
    { text: 'Tipo', value: 'tipo' },
    { text: 'Data de Cadastro', value: 'dataCadastro' },
  ]

  gestoresExibicaoTableHeader: Array<object> = [
    { text: 'Nome', value: 'nome', align: 'start' },
    { text: 'Documento', value: 'documento' },
    { text: 'Tipo', value: 'tipo' },
    { text: 'Data de Cadastro', value: 'dataCadastro' },
  ]

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get contrato() {
    return this.getBackofficeContratosStore.selectedContratoGestor
  }

  maskCPFCNPJUtil(value) {
    return maskCPFCNPJ(value)
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }
}
